import React, { cloneElement } from 'react';
import { Clock, Droplet, Shield, Flame, Moon, Waves, Ban } from 'lucide-react';
export const Aftercare = () => {
  const tips = [{
    icon: <Clock data-id="element-77" />,
    title: 'Espera antes de lavar',
    desc: '48–72 horas para que el tratamiento selle perfectamente'
  }, {
    icon: <Ban data-id="element-78" />,
    title: 'Shampoo sin sulfatos',
    desc: 'Los sulfatos abren la cutícula y reducen la duración'
  }, {
    icon: <Droplet data-id="element-79" />,
    title: 'Hidratación semanal',
    desc: 'Mascarilla 1–2 veces por semana para mantener el brillo'
  }, {
    icon: <Flame data-id="element-80" />,
    title: 'Protector térmico',
    desc: 'Siempre antes de usar plancha o secador'
  }, {
    icon: <Moon data-id="element-81" />,
    title: 'Funda de satén',
    desc: 'Evita el frizz nocturno y la fricción mientras duermes'
  }, {
    icon: <Waves data-id="element-82" />,
    title: 'Protección en piscina/mar',
    desc: 'Aplica acondicionador antes del agua o usa gorro'
  }, {
    icon: <Shield data-id="element-83" />,
    title: 'Evita alcohol en productos',
    desc: 'Reseca el cabello y acorta la duración del tratamiento'
  }];
  return <section className="py-16 bg-beige-50" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 mb-4" data-id="element-87">
            ¿Y después del tratamiento?{' '}
            <span className="italic text-gold-500" data-id="element-88">
              Te enseñamos a cuidarlo
            </span>
          </h2>
          <p className="text-neutral-600" data-id="element-89">
            Porque en Alisados Stefania Becerra no te dejamos sola después de tu
            cita. Cada clienta recibe guía de mantenimiento profesional:
          </p>
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-sm border border-beige-200" data-id="element-90">
          <div className="space-y-6" data-id="element-91">
            {tips.map((tip, index) => <div key={index} className="flex items-start space-x-4 p-4 rounded-2xl hover:bg-beige-50 transition-colors" data-id="element-92">
                <div className="w-12 h-12 bg-gold-50 rounded-full flex items-center justify-center text-gold-500 flex-shrink-0" data-id="element-93">
                  {cloneElement(tip.icon as React.ReactElement, {
                className: 'w-5 h-5'
              })}
                </div>
                <div data-id="element-94">
                  <h4 className="font-medium text-neutral-900 text-lg" data-id="element-95">
                    {tip.title}
                  </h4>
                  <p className="text-neutral-600" data-id="element-96">{tip.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};